import React, { useState, useEffect } from "react"
import fuzzysort from "fuzzysort"
import * as DateFns from "date-fns"

import { Project } from "../../model/types"
import { useNana } from "../hooks/useNana"
import FuzzyFinder, { FuzzyOptions } from "./fuzzy_finder"
import HighlightText from "../../services/highlight_text"

type Result = Fuzzysort.KeysResult<Project> | { obj: Project }

const highlight = (result: Result) =>
  (result as Fuzzysort.KeysResult<Project>)[0].highlight("<b>", "</b>")

const FuzzyProjectFinder = ({
  title,
  chooseProject,
  includeCompleted,
  close,
}: {
  title?: string
  chooseProject: (item: Project) => void
  includeCompleted: boolean
  close: () => void
}) => {
  const { model } = useNana()

  const options: FuzzyOptions<Result> = {
    title: title,

    placeholder: "Search projects...",

    fetchItems: (filter: string): Result[] => {
      const allProjects = model
        .getProjects()
        .filter((p) => {
          if (includeCompleted) return true
          return p.status !== "completed"
        })
        .sort((a, b) => {
          return DateFns.compareAsc(b.updatedAt, a.updatedAt)
        })
      if (filter === "") return allProjects.map((project) => ({ obj: project }))
      const results = fuzzysort.go(filter, allProjects, {
        limit: 20,
        threshold: -1000,
        keys: ["name"],
      })
      return Array.from(results)
    },

    renderItem: (result: Result) => {
      return (
        <div className="min-w-0 flex-1 truncate text-[14px] font-normal text-stone-800 dark:text-stone-200">
          {result["score"] !== undefined && (
            <HighlightText text={highlight(result)} />
          )}
          {result["score"] === undefined && result.obj.name}
        </div>
      )
    },

    getIdForItem: (item: Result) => {
      return item.obj.id
    },

    chooseItem: (item: Result) => {
      chooseProject(item.obj)
    },

    close: close,
  }

  return <FuzzyFinder {...options} />
}

export default FuzzyProjectFinder
